import { observer } from "mobx-react-lite";
import { useState, type ReactNode } from "react";
import { Button } from "../../ui/button";
import { Dialog } from "../../ui/dialog";
import { useAppStores } from "../app-context";
import { researchProjects } from "./branding-config";
import { FundingAcknowledgement } from "./funding-acknowledgement";

export const ProjectInformation = observer(function ProjectInformation(): ReactNode {
  const { locale } = useAppStores();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button onClick={() => { setOpen(true); }} variant="secondary">
        {locale.text("brandingProjectInformation")}
      </Button>
      <Dialog dismissLabel={locale.text("brandingCloseInformation")} onClose={() => { setOpen(false); }} open={open} title={locale.text("brandingProjectInformation")}>
        <div className="c3i-project-information">
          <p>{locale.text("brandingAttribution")}</p>
          {researchProjects.map((project) => (
            <section aria-labelledby={`c3i-project-${project.id}`} className="c3i-project-information__project" key={project.id}>
              <h3 id={`c3i-project-${project.id}`}>{project.name}</h3>
              <p>{locale.text("brandingGrantAgreement")} {project.grant} · {locale.text("brandingHorizonEurope")}</p>
              {project.id === "synergise" ? <FundingAcknowledgement /> : null}
              <p>{locale.text(project.id === "foresight" ? "brandingForesightFunding" : "brandingSynergiseFunding")}</p>
              <a className="c3i-project-information__link" href={project.url} referrerPolicy="no-referrer" rel="noopener noreferrer" target="_blank">
                {locale.text("brandingProjectWebsite")} · {project.name}
              </a>
            </section>
          ))}
        </div>
      </Dialog>
    </>
  );
});
